import { render } from "./NotificationPage.vue?vue&type=template&id=7a0fbe9d&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"

import "./NotificationPage.vue?vue&type=style&index=0&id=7a0fbe9d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0fbe9d"]])

export default __exports__